export default __webpack_public_path__ + "static/media/view3_week_age_.1a80bf33.csv";